import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "register-input" }
const _hoisted_2 = { class: "copy-text" }
const _hoisted_3 = {
  key: 0,
  class: "check-error"
}
const _hoisted_4 = { class: "check" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmallCopyIcon = _resolveComponent("SmallCopyIcon")!
  const _component_DangerTriangle = _resolveComponent("DangerTriangle")!
  const _component_ToggleInput = _resolveComponent("ToggleInput")!
  const _component_TermsModalWithButton = _resolveComponent("TermsModalWithButton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "check-register",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.authorize && _ctx.authorize(...args)), ["prevent"]))
  }, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("modals.login.registration_start_subtitle")), 1),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "register-text" }, " Please add the following phrase to your Roblox description page ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", { ref: "referralLink" }, _toDisplayString(_ctx.state.description), 513),
        _createElementVNode("i", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyDescription && _ctx.copyDescription(...args)))
        }, [
          _createVNode(_component_SmallCopyIcon)
        ])
      ]),
      (_ctx.state.errors.phrase?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("i", null, [
              _createVNode(_component_DangerTriangle)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.errors.phrase, (error) => {
              return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ToggleInput, {
        modelValue: _ctx.state.terms_and_policy,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.terms_and_policy) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("p", null, [
        _cache[4] || (_cache[4] = _createTextVNode(" By checking this box you agree to our ", -1)),
        _createVNode(_component_TermsModalWithButton)
      ])
    ]),
    _createVNode(_component_Button, {
      disabled: !_ctx.state.terms_and_policy || _ctx.authorizing,
      action: "submit",
      type: "primary",
      style: {"width":"100%","height":"52px"}
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createTextVNode(" Sign up ", -1)
      ]))]),
      _: 1
    }, 8, ["disabled"])
  ], 32))
}